/* DISPLAY KLAVIYO POP UP BEFORE DOWNLOADING */
var downloadURL = "";
window.addEventListener("klaviyoForms", function(e) { 
  //alert(e.detail.type);
    if (e.detail.type == 'stepSubmit') {
     //window.location.href=downloadURL;
      if (downloadURL.includes(".gif")) {
      	     window.open(downloadURL, '_blank');
      } else if (downloadURL.includes(".jpg")) {
      	     window.open(downloadURL, '_blank');
      } else if (downloadURL.includes(".pdf")) {
      	     window.open(downloadURL, '_blank');
      } else {
      }
    }
});
/*
document.querySelector(".klaviyo_form_trigger").addEventListener('click',function (e){
e.preventDefault();
window._klOnsite = window._klOnsite || [];	
window._klOnsite.openForm('WRbG6e');	
});
*/
var elements = document.getElementsByClassName("klaviyo_form_trigger");

var myFunction = function(e) {
  e.preventDefault();
  downloadURL = this.getAttribute("href");
  window._klOnsite = window._klOnsite || [];	
  window._klOnsite.openForm('WRbG6e');	
};
/*
for (var i = 0; i < elements.length; i++) {
    elements[i].addEventListener('click', function (e){
      e.preventDefault();
      window._klOnsite = window._klOnsite || [];	
      window._klOnsite.openForm('WRbG6e');	
    });
}
*/
for (var i = 0; i < elements.length; i++) {
    elements[i].addEventListener('click', myFunction, false);
}